import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { FiPlay } from "react-icons/fi";

const videoLinks = [
    "https://youtu.be/15A6cqAXvQg",
    "https://youtu.be/6Bl8GgiNpjo",
    "https://youtu.be/y-NygYKLg14",
    "https://youtu.be/H7218RbYhxs",
    "https://youtu.be/U_9Ysjz4-ls",
    "https://youtu.be/5i7bfcbKJ7E",
    "https://youtu.be/Nb-0YFcJ4OA",

];

function SpeakingVideo() {
  const [toggler, setToggler] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);

  const openLightbox = (index) => {
    setActiveVideo(index);
    setToggler(!toggler);
  };

  const getYouTubeThumbnail = (url) => {
    let videoId = "";
    if (url.includes("youtu.be")) {
      videoId = url.split("youtu.be/")[1].split("?")[0];
    } else if (url.includes("youtube.com")) {
      videoId = url.split("v=")[1]?.split("&")[0];
    }
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  };

  return (
    <div className="row row--15">
      {videoLinks.map((link, index) => (
        <div className="col-lg-4 col-md-6 col-12 mt--30" key={index}>
          <div className="video-popup icon-center">
            <div className="thumbnail">
              <img
                className="radius-small"
                src={getYouTubeThumbnail(link)}
                alt={`Video ${index + 1}`}
              />
            </div>
            <div className="video-icon">
              <button
                className="btn-default rounded-player"
                onClick={() => openLightbox(index)}
              >
                <span>
                  <FiPlay />
                </span>
              </button>
            </div>
          </div>
        </div>
      ))}

      {activeVideo !== null && (
        <FsLightbox toggler={toggler} sources={[videoLinks[activeVideo]]} />
      )}
    </div>
  );
}

export default SpeakingVideo;
